// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "common.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Holds common types, used by other files
//
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * *
 * Represents an Instant in time independent of any timezone or local calendar, encoded as a number of milliseconds
 * since an eopic at midnight on Jan 1st 1970 UTC, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * This is derived from google.protobuf.Timestamp (as nanopb cannot handle Google-defined types), but restricted to millisecond
 * resolution (as we don't need anything more)
 *
 * @generated from protobuf message aeolus.proto.Timestamp
 */
export interface Timestamp {
    /**
     * Represents milliseconds of UTC time since Unix epoch
     * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     * 9999-12-31T23:59:59Z inclusive.
     *
     * @generated from protobuf field: int64 milliseconds = 1;
     */
    milliseconds: bigint;
}
/**
 * *
 * Configuration parameters to send to the device to control the frequency of data updates and live time
 *
 * @generated from protobuf message aeolus.proto.ConfigParams
 */
export interface ConfigParams {
    /**
     * / Time elapsed between data publish events in seconds
     *
     * @generated from protobuf field: int32 publish_interval = 1;
     */
    publishInterval: number;
    /**
     * / Device broadcasting uptime in minutes
     *
     * @generated from protobuf field: int32 on_duration = 2;
     */
    onDuration: number;
    /**
     * / Device offline time (sleep) in minutes
     *
     * @generated from protobuf field: int32 off_duration = 3;
     */
    offDuration: number;
}
/**
 * *
 * Device status is reported by the device
 *
 * @generated from protobuf message aeolus.proto.DeviceStatus
 */
export interface DeviceStatus {
    /**
     * / Whether this device is online or offline. A device can report an OFFLINE status using a Will, or this may be
     * / synthesised by the server
     *
     * @generated from protobuf field: aeolus.proto.DevicePresence presence = 2;
     */
    presence: DevicePresence;
    /**
     * / The currently firmware version on the device. This is currently unstructured text.
     *
     * @generated from protobuf field: string firmware_version = 3;
     */
    firmwareVersion: string;
    /**
     * Date time stamp of the last time the device was seen - recorded by data ingestor
     *
     * @generated from protobuf field: string last_seen = 4;
     */
    lastSeen: string;
    /**
     * The current config params set on the device
     *
     * @generated from protobuf field: aeolus.proto.ConfigParams config_params = 5;
     */
    configParams?: ConfigParams;
}
/**
 * *
 * A single sensor reading
 *
 * @generated from protobuf message aeolus.proto.SensorReading
 */
export interface SensorReading {
    /**
     * / Time at which the reading was taken
     *
     * @generated from protobuf field: aeolus.proto.Timestamp timestamp = 1;
     */
    timestamp?: Timestamp;
    /**
     * / The value of the reading. The unit of this value depends on the value of the sensor_type field
     *
     * @generated from protobuf field: float value = 2;
     */
    value: number;
    /**
     * / The sensor type which produced this reading
     *
     * @generated from protobuf field: aeolus.proto.SensorType sensor_type = 3;
     */
    sensorType: SensorType;
}
/**
 * @generated from protobuf enum aeolus.proto.DevicePresence
 */
export enum DevicePresence {
    /**
     * @generated from protobuf enum value: DevicePresence_ONLINE = 0;
     */
    DevicePresence_ONLINE = 0,
    /**
     * @generated from protobuf enum value: DevicePresence_OFFLINE = 1;
     */
    DevicePresence_OFFLINE = 1
}
/**
 * *
 * Represents the different types of sensors
 *
 * @generated from protobuf enum aeolus.proto.SensorType
 */
export enum SensorType {
    /**
     * / Temperature. Units: Degrees C
     *
     * @generated from protobuf enum value: TEMPERATURE = 0;
     */
    TEMPERATURE = 0,
    /**
     * / Relative humidity. Units: %
     *
     * @generated from protobuf enum value: HUMIDITY = 1;
     */
    HUMIDITY = 1,
    /**
     * / Atmospheric pressure. Units: kPa
     *
     * @generated from protobuf enum value: ATMOSPHERIC_PRESSURE = 2;
     */
    ATMOSPHERIC_PRESSURE = 2,
    /**
     * / Gas resistance. Units: Ohms
     *
     * @generated from protobuf enum value: GAS_RES = 3;
     */
    GAS_RES = 3,
    /**
     * / Acceleration on axes. Units: m/s^2
     *
     * @generated from protobuf enum value: ACCEL_X = 4;
     */
    ACCEL_X = 4,
    /**
     * @generated from protobuf enum value: ACCEL_Y = 5;
     */
    ACCEL_Y = 5,
    /**
     * @generated from protobuf enum value: ACCEL_Z = 6;
     */
    ACCEL_Z = 6,
    /**
     * / Angular velocity around axes. Units: radians/s
     *
     * @generated from protobuf enum value: GYRO_X = 7;
     */
    GYRO_X = 7,
    /**
     * @generated from protobuf enum value: GYRO_Y = 8;
     */
    GYRO_Y = 8,
    /**
     * @generated from protobuf enum value: GYRO_Z = 9;
     */
    GYRO_Z = 9,
    /**
     * / Magnetic field on axes. Units: Gauss
     *
     * @generated from protobuf enum value: MAGN_X = 10;
     */
    MAGN_X = 10,
    /**
     * @generated from protobuf enum value: MAGN_Y = 11;
     */
    MAGN_Y = 11,
    /**
     * @generated from protobuf enum value: MAGN_Z = 12;
     */
    MAGN_Z = 12,
    /**
     * / Illuminance in visible spectrum. Units: lux
     *
     * @generated from protobuf enum value: AMBIENT_LIGHT = 13;
     */
    AMBIENT_LIGHT = 13,
    /**
     * / Gas gauge outputs
     *
     * Units: V
     *
     * @generated from protobuf enum value: BATT_VOLTAGE = 14;
     */
    BATT_VOLTAGE = 14,
    /**
     * Units: mA
     *
     * @generated from protobuf enum value: BATT_CURRENT = 15;
     */
    BATT_CURRENT = 15,
    /**
     * Units: %
     *
     * @generated from protobuf enum value: BATT_SOC = 16;
     */
    BATT_SOC = 16,
    /**
     * / GNSS outputs
     *
     * @generated from protobuf enum value: GNSS_LAT = 17;
     */
    GNSS_LAT = 17,
    /**
     * @generated from protobuf enum value: GNSS_LON = 18;
     */
    GNSS_LON = 18,
    /**
     * @generated from protobuf enum value: GNSS_ALT = 19;
     */
    GNSS_ALT = 19,
    /**
     * @generated from protobuf enum value: GNSS_SPEED = 20;
     */
    GNSS_SPEED = 20,
    /**
     * / ADC outputs
     *
     * @generated from protobuf enum value: CURRENT = 21;
     */
    CURRENT = 21,
    /**
     * @generated from protobuf enum value: VOLTAGE = 22;
     */
    VOLTAGE = 22
}
// @generated message type with reflection information, may provide speed optimized methods
class Timestamp$Type extends MessageType<Timestamp> {
    constructor() {
        super("aeolus.proto.Timestamp", [
            { no: 1, name: "milliseconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<Timestamp>): Timestamp {
        const message = { milliseconds: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Timestamp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Timestamp): Timestamp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 milliseconds */ 1:
                    message.milliseconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Timestamp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 milliseconds = 1; */
        if (message.milliseconds !== 0n)
            writer.tag(1, WireType.Varint).int64(message.milliseconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.Timestamp
 */
export const Timestamp = new Timestamp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigParams$Type extends MessageType<ConfigParams> {
    constructor() {
        super("aeolus.proto.ConfigParams", [
            { no: 1, name: "publish_interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "on_duration", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "off_duration", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ConfigParams>): ConfigParams {
        const message = { publishInterval: 0, onDuration: 0, offDuration: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ConfigParams>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfigParams): ConfigParams {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 publish_interval */ 1:
                    message.publishInterval = reader.int32();
                    break;
                case /* int32 on_duration */ 2:
                    message.onDuration = reader.int32();
                    break;
                case /* int32 off_duration */ 3:
                    message.offDuration = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfigParams, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 publish_interval = 1; */
        if (message.publishInterval !== 0)
            writer.tag(1, WireType.Varint).int32(message.publishInterval);
        /* int32 on_duration = 2; */
        if (message.onDuration !== 0)
            writer.tag(2, WireType.Varint).int32(message.onDuration);
        /* int32 off_duration = 3; */
        if (message.offDuration !== 0)
            writer.tag(3, WireType.Varint).int32(message.offDuration);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.ConfigParams
 */
export const ConfigParams = new ConfigParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceStatus$Type extends MessageType<DeviceStatus> {
    constructor() {
        super("aeolus.proto.DeviceStatus", [
            { no: 2, name: "presence", kind: "enum", T: () => ["aeolus.proto.DevicePresence", DevicePresence] },
            { no: 3, name: "firmware_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_seen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "config_params", kind: "message", T: () => ConfigParams }
        ]);
    }
    create(value?: PartialMessage<DeviceStatus>): DeviceStatus {
        const message = { presence: 0, firmwareVersion: "", lastSeen: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeviceStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeviceStatus): DeviceStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* aeolus.proto.DevicePresence presence */ 2:
                    message.presence = reader.int32();
                    break;
                case /* string firmware_version */ 3:
                    message.firmwareVersion = reader.string();
                    break;
                case /* string last_seen */ 4:
                    message.lastSeen = reader.string();
                    break;
                case /* aeolus.proto.ConfigParams config_params */ 5:
                    message.configParams = ConfigParams.internalBinaryRead(reader, reader.uint32(), options, message.configParams);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeviceStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* aeolus.proto.DevicePresence presence = 2; */
        if (message.presence !== 0)
            writer.tag(2, WireType.Varint).int32(message.presence);
        /* string firmware_version = 3; */
        if (message.firmwareVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firmwareVersion);
        /* string last_seen = 4; */
        if (message.lastSeen !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastSeen);
        /* aeolus.proto.ConfigParams config_params = 5; */
        if (message.configParams)
            ConfigParams.internalBinaryWrite(message.configParams, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.DeviceStatus
 */
export const DeviceStatus = new DeviceStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SensorReading$Type extends MessageType<SensorReading> {
    constructor() {
        super("aeolus.proto.SensorReading", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "sensor_type", kind: "enum", T: () => ["aeolus.proto.SensorType", SensorType] }
        ]);
    }
    create(value?: PartialMessage<SensorReading>): SensorReading {
        const message = { value: 0, sensorType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SensorReading>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SensorReading): SensorReading {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* aeolus.proto.Timestamp timestamp */ 1:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* float value */ 2:
                    message.value = reader.float();
                    break;
                case /* aeolus.proto.SensorType sensor_type */ 3:
                    message.sensorType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SensorReading, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* aeolus.proto.Timestamp timestamp = 1; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* float value = 2; */
        if (message.value !== 0)
            writer.tag(2, WireType.Bit32).float(message.value);
        /* aeolus.proto.SensorType sensor_type = 3; */
        if (message.sensorType !== 0)
            writer.tag(3, WireType.Varint).int32(message.sensorType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.SensorReading
 */
export const SensorReading = new SensorReading$Type();
